import { Outlet, type RouteObject } from 'react-router-dom';
import { CONTEXTS } from '@/app/registry';

export const adminSkillsRoutes: RouteObject[] = [
  {
    path: 'admin/skills',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_SKILLS, title: 'Compétences' },
  },
  {
    path: 'admin/skills/new',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_SKILL_FORM, title: 'Nouvelle compétence' },
  },
  {
    path: 'admin/skills/:skillId/edit',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_SKILL_FORM, title: 'Modifier la compétence' },
  },
];
